export const LEGAL_REPRESENTATIVE_POPUP_OPEN_POPUP =
    "@LEGAL_REPRESENTATIVE_POPUP/OPEN_POPUP";

export const LEGAL_REPRESENTATIVE_POPUP_CLOSE_POPUP =
    "@LEGAL_REPRESENTATIVE_POPUP/CLOSE_POPUP";

export const LEGAL_REPRESENTATIVE_POPUP_SUBMIT_FORM =
    "@LEGAL_REPRESENTATIVE_POPUP/SUBMIT_FORM";

export const LEGAL_REPRESENTATIVE_POPUP_SUBMIT_FORM_DONE =
    "@LEGAL_REPRESENTATIVE_POPUP/SUBMIT_FORM_DONE";

export const LEGAL_REPRESENTATIVE_POPUP_VERIFY_IF_CUSTOMER_HAS_LEGAL_REPRESENTATIVE =
    "@LEGAL_REPRESENTATIVE_POPUP/VERIFY_IF_CUSTOMER_HAS_LEGAL_REPRESENTATIVE";

export const SAVE_LEGAL_REPRESENTATIVE =
    "@LEGAL_REPRESENTATIVE_POPUP/SAVE_LEGAL_REPRESENTATIVE";
